
import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { RL1SlipSetup } from "../../../components/RL1Slip";

export interface IRL1SlipSetupPage {}

export const RL1SlipSetupPage: FC<IRL1SlipSetupPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Create RL-1 Slip"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Compliance", navigateTo: "/compliance/rl1/list" },
        // { text: "RL-1", navigateTo: "/compliance/rl1/list" },
        // { text: "Create RL-1 Slip", navigateTo: "/compliance/rl1/setup" },
      ]}
      mainContents={<RL1SlipSetup testId="rl1-slip-setup" />}
    />
  );
};
